<template>
  <base-message :message="message">
    <div class="loading-message">
      {{ message.status }}
      <loading-dot></loading-dot>
    </div>
  </base-message>
</template>

<script>
  import LoadingDot from './LoadingDot'
  import BaseMessage from './BaseMessage'

  export default {
    components: {LoadingDot, BaseMessage},
    props: ['message']
  }
</script>

<style lang="stylus" scoped>
  .text-message {
    padding .5em .75em
  }
</style>
